export const MAX_MARKER_MISS_TIME = 5 * 1000 // 5s
export const MAX_LAST_SEEN = 30 * 1000 // 30s

export default class ADSBMarkerSet {
  constructor(name, options = {}, overlayParent) {

    this.parentSegment = addOverlay(name, null, overlayParent)

    this.addedLayer = true
    this.layer = L.layerGroup()
    this.layer.addTo(mymap)
    addOverlay("Markers", this.layer, this.parentSegment)

    this.headingLayer = L.layerGroup()
    this.headingLayer.addTo(this.layer)
    addOverlay("Headings", this.headingLayer, this.parentSegment)

    this.options = {
      maxLastSeen: options.maxLastSeen || MAX_LAST_SEEN
    }

    this.markers = {}
  }

  update(data, now) {
    if (!now) now = Date.now()

    let markerInfo = this.markers[data.icao]

    if (now - data.lastSeen > this.options.maxLastSeen) {
      // console.log("Skipping stale", data.callsign || data.icao, now, data.lastSeen, (now - data.lastSeen)/1000)
      if (markerInfo) {
        if (markerInfo.marker) markerInfo.marker.removeFrom(this.layer)
        if (markerInfo.line) markerInfo.line.removeFrom(this.headingLayer)
        delete this.markers[data.icao]
      }
      return
    }

    let pos = [data.latitude, data.longitude]
    // Get a marker for a new one
    const {details, title} = this.getDetails(data)
    if (!markerInfo) {
      const iconConfig = L.icon({
        iconUrl: planeIcon,
        iconSize: [20, 20],
        iconAnchor: [10, 10]
      });
    
      let marker = L.marker(pos, { icon: iconConfig, title })
      marker.addTo(this.layer);
      markerInfo = {marker, details}
      this.markers[data.icao] = markerInfo
    }
    // if (!details) details = this.getDetails(data).details
    markerInfo.marker.setLatLng(pos)
    markerInfo.marker.bindPopup(details)
    markerInfo.timestamp = data.lastSeen
    if (data.headingDE2) {
      if (markerInfo.line) {
        markerInfo.line.removeFrom(this.headingLayer)
      }
      if (mymap.getZoom() < 9) return
      const pt = mymap.latLngToContainerPoint(pos)
      let cartHeading = data.headingDE2 / 100 - 90
      if (cartHeading < 0) cartHeading += 360
      const rads = cartHeading * Math.PI / 180
      const cosRads = Math.cos(rads)
      const sinRads = Math.sin(rads)
      const len = ((data.horVelocityCMS || 100) / 51.4444) / 100 * 10
      const newPt = [pt.x + cosRads * len, pt.y + sinRads * len]
      markerInfo.line = L.polyline([pos, mymap.containerPointToLatLng(newPt)], {color: "yellow", weight:1})
      markerInfo.line.addTo(this.headingLayer)
    }
  }

  getDetails(data) {
    let details = "ICAO: " + data.icao;
    let title;
    if (data.callsign && data.callsign.trim()) {
      details += "<br>Callsign: " + data.callsign.trim();
      title = data.callsign.trim();
    }
    else {
      title = data.icao;
    }
    if (data.emitterType) {
      details += "<br>Type: " + targetEmitTypeString[data.emitterType];
    }
    if (data.altitude) {
      details += "<br>Altitude: " + Math.round(data.altitude / 304.8) + " ft";
    }
    if (data.headingDE2) {
      details += "<br>Heading: " + Math.round(data.headingDE2 / 100);
    }
    if (data.horVelocityCMS) {
      details += "<br>Velocity: " + Math.round(data.horVelocityCMS / 51.4444) + " knots";
    }
    if (data.squawk) {
      details += "<br>Squawk: " + data.squawk;
    }
    if (data.lastSeen) {
      details += "<br>Last Update: " + new Date(data.lastSeen).toLocaleString()
    }
  
    return {details, title}
  }

  clean(timestamp) {
    for (const [key, markerInfo] of Object.entries(this.markers)) {
      if (timestamp - markerInfo.timestamp > this.options.maxLastSeen) {
        markerInfo.marker.removeFrom(this.layer)
        if (markerInfo.line) markerInfo.line.removeFrom(this.headingLayer)
        delete this.markers[key]
      }
    }
  }

  clear() {
    for (const markerInfo of Object.values(this.markers)) {
      if (markerInfo.marker) markerInfo.marker.removeFrom(this.layer)
      if (markerInfo.line) markerInfo.line.removeFrom(this.headingLayer)
    }
    this.markers = []
  }

  cleanup() {
    this.clear()
    removeOverlay(this.parentSegment)
  }
}
